import { t as e } from "../../../v99990101-BzXA787k.js";
export { e as dashboardv99990101Client };
